export default {
  empty: 'No part instances found.',
  addPart: 'Add part',
  editPart: 'Edit part',
  createOrder: 'Create order',
  selectOrder: 'Select an order (optional)',
  selectRevision: 'Select a part revision',
  confirmDelete: 'Delete part "{part}" from this load?',
};
